import form from './form';
import register from './register';
import pages from "./pages";
import apps_sidebar from "./apps_sidebar";
import components from './components';

export default {
    form,
    register,
    "offline_mode": {
        "online": "You are back online.",
        "offline": "We can no longer detect your internet connection.",
        "banner": {
        "text": "Attention, your internet connection seems to have a problem."
        }
    },
    "pagination": {
        "prev": "<",
        "next": ">"
    },
    "table": {
        "empty": "No information at this time."
    },
    "misc": {
        "confirm_page_leave": "Are you sure you want to leave this page? Your changes will be lost.",
        "confirm": "Are you sure you want to continue?",
        "back_button": "Back",
        "date_time": "On {date} at {time}"
    },
    apps_sidebar: {
        account: 'My account',
        help: 'Help'
    },
    help_submenu: {
        label: 'Help',
        help: {
            link: 'https://pro.trustup.be/aide',
            text: "Help center",
        },
        support: {
            link: 'https://pro.trustup.be/support/',
            text: "Contact our support",
        },
        chat: {
            text: "Chat",
        }
    },
    components,
    pages,
    apps_sidebar
}